import { isNil } from '@flowio/is';
import { PaymentStatus } from '@flowio/api-constants';
import isInternalPaymentRequest from '../../validators/isInternalPaymentRequest';
import loadScript from '../../utilities/loadScript';
import pollForPrUpdate from '../../utilities/pollForPrUpdate';
import { showLoadingSpinner, hideLoadingSpinner } from '../../utilities/loadingSpinner';

const STRIPE_JAVASCRIPT = 'https://js.stripe.com/v3/';

export default function handleStripeV3Action(
  pr: io.flow.v0.models.PaymentRequest | io.flow.internal.v0.models.InternalPaymentRequest,
  action: io.flow.v0.models.ActionUseSdkStripeV3,
): Promise<io.flow.v0.models.PaymentRequest | io.flow.internal.v0.models.InternalPaymentRequest> {
  if (isNil(action) || action.type !== 'use_sdk_stripe_v3') {
    throw new Error('handleStripeV3Action: method inappropriately invoked.');
  }
  showLoadingSpinner();

  return loadScript(STRIPE_JAVASCRIPT).then(() => {
    const stripe = Stripe(action.publishable_key);

    hideLoadingSpinner();
    return stripe.confirmCardPayment(action.client_secret)
      .then((): Promise<
      io.flow.v0.models.PaymentRequest | io.flow.internal.v0.models.InternalPaymentRequest
      > => new Promise((resolve, reject) => {
        showLoadingSpinner();
        pollForPrUpdate(pr, {
          diffCheck: (_pr1, pr2) => {
            const status = isInternalPaymentRequest(pr2) ? pr2.payment_request.status : pr2.status;
            return status !== PaymentStatus.REQUIRES_ACTION;
          },
          startInterval: 1,
          timeoutInterval: 20,
          onChange: resolve,
          onTimeout: reject,
        });
      }))
      .finally(() => {
        hideLoadingSpinner();
      });
  });
}
